import { AppConfig } from 'common/interfaces';

const DEPLOYMENT_ENV: 'dev' | 'stage' | 'prod' = 'stage';

type IBuildConfig = {
  codePushDeploymentKey: string;
};
let BuildConfig = {} as IBuildConfig;
//@ts-ignore
const loggingReq = DEPLOYMENT_ENV == 'prod';

if (loggingReq) {
  // Override console methods
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const prod = {
  envType: 'prod',
  version: 1,
  api: {
    rest: 'https://reports.xprotean.com',
  },
  appConfig: {
    appVersionId: '1',
  },
} as ConfigType;

const stage = {
  envType: 'stage',
  version: 1,
  api: {
    rest: 'https://reports.binarytechlab.com',
  },
  appConfig: {
    appVersionId: '1',
  },
} as ConfigType;

const dev = {
  envType: 'dev',
  version: 1,
  api: {
    rest: 'http://localhost:9001',
  },
  appConfig: {
    appVersionId: '1',
  },
} as ConfigType;

type ConfigType = {
  envType: 'prod' | 'dev' | 'stage';
  api: {
    rest: string;
  };
  version: number;
  appConfig: AppConfig;
};

type Stages = {
  [key: string]: ConfigType;
};

const stages: Stages = { dev, stage, prod };

export const config = stages[DEPLOYMENT_ENV];
export { BuildConfig };
